var exports = {
  "y": "divider__y0sXw0",
};

module.exports = exports;
